import React, { useRef } from 'react';
import image1 from '../asset/blooddonationimage/image1.jpg';
import image2 from '../asset/blooddonationimage/image2.jpg';
import image3 from '../asset/blooddonationimage/image3.jpg';
import image4 from '../asset/blooddonationimage/image4.jpg';
import image5 from '../asset/blooddonationimage/image5.jpg';
import image6 from '../asset/blooddonationimage/image6.jpg';
import image7 from '../asset/blooddonationimage/image7.jpg';
import image8 from '../asset/blooddonationimage/image8.jpg';
import image9 from '../asset/blooddonationimage/image9.jpg';
import image10 from '../asset/blooddonationimage/image10.jpg';
import image11 from '../asset/blooddonationimage/image11.jpg';
import image12 from '../asset/blooddonationimage/image12.jpg';
import image13 from '../asset/blooddonationimage/image13.jpg';
import image14 from '../asset/blooddonationimage/image14.jpg';
import image15 from '../asset/blooddonationimage/image15.jpg';
import image16 from '../asset/blooddonationimage/image16.jpg';
import image17 from '../asset/blooddonationimage/image17.jpg';
import image18 from '../asset/blooddonationimage/image18.jpg';
import image19 from '../asset/blooddonationimage/image19.jpg';
import DonationCounter from './DonationCounter';
import DonorStories from './DonorStories';

const BloodDonation = () => {
  const floatingButtonRef = useRef(null);

  const handleDonateClick = () => {
    // Trigger the floating donation button
    if (floatingButtonRef.current) {
      floatingButtonRef.current.click();
    }
  };

  const sections = [
    {
      title: "Why Donate Blood?",
      content: "Blood donation is a simple act of kindness that can save up to three lives. Every two seconds, someone in India needs blood. Your donation can help accident victims, surgery patients, and those battling life-threatening diseases. Join us in our mission to ensure a safe and sufficient blood supply for our community.",
      image: image1
    },
    {
      title: "The Donation Process",
      content: "Donating blood is safe, simple, and takes only about an hour of your time. Our trained medical staff will guide you through the entire process, from registration to post-donation care. The actual donation takes only 8-10 minutes, and you can return to your normal activities after a short rest.",
      image: image2
    },
    {
      title: "Who Can Donate?",
      content: "If you're between 18-65 years old, weigh at least 50 kg, and are in good health, you can be a blood donor. Regular health check-ups are conducted before donation to ensure your safety. Donors should have a hemoglobin level of at least 12.5 g/dl and should not have any major illnesses.",
      image: image3
    },
    {
      title: "Blood Types and Compatibility",
      content: "Understanding blood types is crucial for safe transfusions. Type O negative is the universal donor, while Type AB positive is the universal recipient. Our blood bank maintains a diverse inventory to meet all transfusion needs. Regular donors help us maintain this critical supply.",
      image: image4
    },
    {
      title: "Community Impact",
      content: "Your donation directly impacts our local community. We organize regular blood donation camps and maintain a network of voluntary donors. Through our efforts, we've helped thousands of patients in Hisar and surrounding areas. Join our community of life-savers today.",
      image: image5
    }
  ];

  return (
    <div className="blood-donation">
      <div className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <p className="text-xl text-center mb-12 text-black">Join us in our mission to save lives through blood donation.</p>
          
          <div className="space-y-16">
            {sections.map((section, index) => (
              <div 
                key={index} 
                className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8`}
              >
                {/* Text Content */}
                <div className="flex-1 space-y-4">
                  <h3 className="text-2xl font-bold text-blue-400">{section.title}</h3>
                  <p className="text-black text-lg leading-relaxed">{section.content}</p>
                </div>
                
                {/* Image */}
                <div className="flex-1">
                  <img 
                    src={section.image} 
                    alt={section.title}
                    className="w-full h-[400px] object-cover rounded-lg shadow-xl hover:scale-[1.02] transition-transform duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Donation Counter Section */}
      {/* <DonationCounter onDonateClick={handleDonateClick} /> */}

      {/* Donor Stories Section */}
      <DonorStories />
    </div>
  );
};

export default BloodDonation; 